import { Link } from 'react-router'
import { useTranslation } from 'react-i18next'

import { LanguageSwitcher } from '../../app/LanguageSwitcher'
import logoUrl from '../../assets/truckers-corner-logo.png'

/**
 * Public marketing page at "/" while the apex site does not exist (decision
 * 2026-08-18). It must stay independent from the authenticated shell so the same
 * layout can move to Cloudflare Pages without untangling anything.
 */
export function LandingPage() {
  const { t } = useTranslation()

  return (
    <div className="landing">
      <header className="landing__nav">
        <div className="brand">
          <span className="brand__mark" aria-hidden="true">
            TC
          </span>
          <span>
            <strong className="brand__name">{t('app.name')}</strong>
            <span className="brand__tagline">{t('app.tagline')}</span>
          </span>
        </div>
        <div className="landing__nav-actions">
          <LanguageSwitcher />
          <Link className="button landing__button" to="/login">
            {t('landing.portalCta')}
          </Link>
        </div>
      </header>

      <main>
        <section className="landing__hero">
          <div>
            <h1>{t('landing.headline')}</h1>
            <p>{t('landing.sub')}</p>
            <Link className="button landing__button" to="/login">
              {t('landing.open')}
            </Link>
          </div>
          {/* Full artwork, plate included, matching the login (Lino, 2026-08-28).
              Still decorative for assistive tech: the header right beside it
              typesets the name, and the hero must not announce it twice. */}
          <svg className="landing__logo" viewBox="0 0 470 470" aria-hidden="true">
            <image href={logoUrl} width="470" height="470" />
          </svg>
        </section>

        <section className="landing__features" aria-label={t('landing.featuresLabel')}>
          <article className="landing__feature">
            <h2>{t('landing.features.sourcing.title')}</h2>
            <p>{t('landing.features.sourcing.body')}</p>
          </article>
          <article className="landing__feature">
            <h2>{t('landing.features.rateconf.title')}</h2>
            <p>{t('landing.features.rateconf.body')}</p>
          </article>
          <article className="landing__feature">
            <h2>{t('landing.features.billing.title')}</h2>
            <p>{t('landing.features.billing.body')}</p>
          </article>
        </section>
      </main>

      <footer className="landing__footer">
        {t('landing.footer', { year: new Date().getFullYear() })}
      </footer>
    </div>
  )
}
